"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const NavOption = _ref => {
  let {
    displayIcons,
    option,
    children,
    menuBarTheme
  } = _ref;
  const childCompRef = (0, _react.useRef)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, displayIcons ? /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar__nav--with-icons",
    onClick: e => childCompRef.current.handleClick(e)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar__nav--with-icons--icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: option?.icon,
    size: `20px`,
    color: menuBarTheme === "blue" ? "#ffffff" : "#0063a3",
    className: `ter-navbar__nav--icon `
  })), /*#__PURE__*/_react.default.cloneElement(children, {
    ref: childCompRef
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children));
};
var _default = NavOption;
exports.default = _default;